import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Terms from './views/TermsAndConditions.vue';
import Privacy from './views/PrivacyPolicy.vue';
import Obligations from './views/Obligations.vue';
import HowItWorks from './views/HowItWorks.vue';
import ShortTermLoans from './views/ShortTermLoans.vue';
import DirectLenderLoans from './views/DirectLenderLoans.vue';
import BadCreditLoans from './views/BadCreditLoans.vue';
import PaydayLoans from './views/PaydayLoans.vue';
import SameDayLoans from './views/SameDayLoans.vue';
import InstantCashLoans from './views/InstantCashLoans.vue';
import Faq from './views/Faq.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/terms-conditions',
      name: 'terms-condtions',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: Terms,
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: Privacy,
    },
    {
      path: '/obligations',
      name: 'obligations',
      component: Obligations,
    },
    {
      path: '/how-it-works',
      name: 'how-it-works',
      component: HowItWorks,
    },
    {
      path: '/faq',
      name: 'faq',
      component: Faq,
    },
    {
      path: '/short-term-loans',
      name: 'short-term-loans',
      component: ShortTermLoans,
    },
    {
      path: '/direct-lender-loans',
      name: 'direct-lender-loans',
      component: DirectLenderLoans,
    },
    {
      path: '/bad-credit-loans',
      name: 'bad-credit-loans',
      component: BadCreditLoans,
    },
    {
      path: '/payday-loans',
      name: 'payday-loans',
      component: PaydayLoans,
    },
    {
      path: '/same-day-loans',
      name: 'same-day-loans',
      component: SameDayLoans,
    },
    {
      path: '/instant-cash-loans',
      name: 'instant-cash-loans',
      component: InstantCashLoans,
    },
    {
      path: '/loan-application',
      name: 'form1',
      component: () => import(/* webpackChunkName: "form1" */ './views/Form1.vue'),
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import(/* webpackChunkName: "contact" */ './views/Contact.vue'),
    },
    {
      path: '/application',
      name: 'formif',
      component: () => import(/* webpackChunkName: "formif" */ './views/FormIf.vue'),
    },
    {
      path: '/lp2',
      name: 'lp2',
      component: () => import(/* webpackChunkName: "formif" */ './views/Lp2.vue'),
    },
  ],
});
